export default __webpack_public_path__ + "static/media/p7.a9ec65cc.PNG";